// chimney-separate-refresh-20260515-2
(function () {
  var params = new URLSearchParams(window.location.search || '');
  var forced = (params.get('force_locale') || '').toLowerCase();
  var pathLocale = (window.location.pathname.match(/^\/(en|es|fr|it)(\/|$)/) || [])[1] || '';
  var htmlLocale = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
  var locale = forced || pathLocale || htmlLocale;

  var catalog = window.SaunamoHeaterLocaleCatalog && window.SaunamoHeaterLocaleCatalog[locale];

  document.documentElement.setAttribute('lang', locale);
  if (document.body) {
    document.body.classList.add('saunamo-heater-locale-active', 'saunamo-heater-locale-' + locale);
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function preserveWhitespace(original, replacement) {
    var start = (original.match(/^\s*/) || [''])[0];
    var end = (original.match(/\s*$/) || [''])[0];
    return start + replacement + end;
  }

  function skipElement(element) {
    if (!element) return true;
    return Boolean(
      element.closest &&
      element.closest('script, style, noscript, svg, [data-saunamo-locale-skip="true"]')
    );
  }

  function chimneyText(options) {
    return options[locale] || options.en || '';
  }

  function rewriteChimneyClaim(key) {
    if (!/(chimney|chamin[eé]|chimenea|chemin[eé]e|canna fumaria|camino)/i.test(key)) return '';
    if (/(sold separately|vendido separadamente|vendida separadamente|se vende por separado|vendu séparément|vendue séparément|venduto separatamente|separately|separado|separada|separato|separata|séparé|séparée|aparte|à parte)/i.test(key)) return '';

    if (/^(chamin[eé]\s+inclu[ií]da|chimney included|chimenea incluida|chemin[eé]e incluse|canna fumaria inclusa|camino incluso)$/i.test(key)) {
      return chimneyText({
        en: 'Chimney set separate',
        es: 'Chimenea aparte',
        fr: 'Kit cheminée séparé',
        it: 'Kit canna fumaria separato'
      });
    }

    if (/(operação manual a lenha|manual wood-(?:fired|burning) operation|funcionamiento manual de leña|fonctionnement manuel au bois|funzionamento manuale a legna).*(chamin[eé]\s+inclu[ií]da|chimney included|chimenea incluida|chemin[eé]e incluse|canna fumaria inclusa)/i.test(key)) {
      return chimneyText({
        en: 'Manual wood-burning operation · chimney set sold separately',
        es: 'Funcionamiento manual de leña · chimenea aparte',
        fr: 'Fonctionnement manuel au bois · kit cheminée séparé',
        it: 'Funzionamento manuale a legna · kit canna fumaria separato'
      });
    }

    if (/(chamin[eé]\s+inclu[ií]da|chimney included|chimenea incluida|chemin[eé]e incluse|canna fumaria inclusa).*(operação manual|manual wood|funcionamiento manual|fonctionnement manuel|funzionamento manuale)/i.test(key)) {
      return chimneyText({
        en: 'Manual wood-fired operation',
        es: 'Funcionamiento manual a leña',
        fr: 'Fonctionnement manuel au bois',
        it: 'Funzionamento manuale a legna'
      });
    }

    if (/(a chamin[eé] est[áa] inclu[ií]da\?|is the chimney included\?|chimenea est[áa] incluida\?|la cheminée est-elle incluse|canna fumaria .*inclusa\?)/i.test(key)) {
      return chimneyText({
        en: 'How do I order the chimney set?',
        es: '¿Cómo pido el conjunto de chimenea?',
        fr: 'Comment commander le kit cheminée ?',
        it: 'Come ordino il kit canna fumaria?'
      });
    }

    if (/(chamin[eé]\s+(vem|est[áa] inclu)|chimney (comes|is included)|chimenea (viene|est[áa] incluida)|chemin[eé]e (est incluse|est fournie)|canna fumaria .*inclusa|camino .*incluso|no separate purchase needed|no hace falta comprarla aparte|pas d’achat séparé nécessaire|non serve acquistarla separatamente)/i.test(key)) {
      return chimneyText({
        en: 'No. The chimney set is sold separately and should be added when you confirm the roof or wall route.',
        es: 'No. El conjunto de chimenea se vende por separado y debe añadirse al pedido al confirmar el recorrido por tejado o pared.',
        fr: 'Non. Le kit cheminée est vendu séparément et doit être ajouté lorsque le passage par le toit ou le mur est confirmé.',
        it: 'No. Il kit canna fumaria è venduto separatamente e va aggiunto quando confermi il passaggio a tetto o parete.'
      });
    }

    return '';
  }

  function translateTextNode(node) {
    var raw = node.nodeValue || '';
    var key = normalize(raw);
    if (!key) return;
    var chimneyRewrite = rewriteChimneyClaim(key);
    if (chimneyRewrite && chimneyRewrite !== key) {
      node.nodeValue = preserveWhitespace(raw, chimneyRewrite);
      return;
    }
    var translated = catalog[key] || translatePrefix(key);
    if (!translated || translated === key) return;
    node.nodeValue = preserveWhitespace(raw, translated);
  }

  function translatePrefix(key) {
    var delimiters = [' — ', ' – ', ' - ', ' · ', ': '];
    for (var index = 0; index < delimiters.length; index += 1) {
      var delimiter = delimiters[index];
      var delimiterPosition = key.indexOf(delimiter);
      if (delimiterPosition <= 0) continue;
      var prefix = key.slice(0, delimiterPosition);
      if (catalog[prefix]) return catalog[prefix] + key.slice(delimiterPosition);
    }
    return '';
  }

  function translateTree(root) {
    if (!root || skipElement(root.nodeType === 1 ? root : root.parentElement)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return skipElement(node.parentElement) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
  }

  function rewriteDraftLanguageLinks() {
    var previewId = params.get('preview_theme_id') || '199512392019';
    var domainMap = {
      pt: 'https://saunamo.pt',
      en: 'https://saunamo.shop',
      es: 'https://saunamo.es',
      fr: 'https://saunamo.fr',
      it: 'https://saunamo.it'
    };
    document.querySelectorAll('.saunamo-native-language__link[hreflang]').forEach(function (link) {
      var target = (link.getAttribute('hreflang') || '').slice(0, 2).toLowerCase();
      if (!/^(pt|en|es|fr|it)$/.test(target)) return;
      if (!params.has('preview_theme_id') && !params.has('force_locale') && !params.has('force_en')) {
        var cleanHref = domainMap[target] + window.location.pathname;
        link.href = cleanHref;
        link.setAttribute('data-clean-url', cleanHref);
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('preview_theme_id', previewId);
      url.searchParams.delete('force_en');
      if (target === 'pt') {
        url.searchParams.delete('force_locale');
      } else {
        url.searchParams.set('force_locale', target);
        if (target === 'en') url.searchParams.set('force_en', '1');
        else url.searchParams.set('force_en', '0');
      }
      link.href = url.toString();
    });
  }

  function run() {
    rewriteDraftLanguageLinks();
    if (!/^(en|es|fr|it)$/.test(locale)) return;
    if (locale === 'en' && params.get('force_en') === '0') return;
    if (!catalog) return;
    translateTree(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    if (!/^(en|es|fr|it)$/.test(locale) || !catalog) return;
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        translateTextNode(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
        else if (node.nodeType === Node.ELEMENT_NODE) translateTree(node);
      });
    });
  });
  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  }
})();
